const manageAccess = {
    title: 'Common_ManageAccess',
    route: '/manageAccess',
    icon: {
        small: 'ManageAccess',
    },
}

export default manageAccess
